import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DialogDecorated, DialogBody, DialogFooter, DialogTitle } from 'components/redux-dialog';
import { Button } from 'components/button';
import { hideDialogAction } from 'components/redux-dialog/actions';

export const UNSUPPORTED_FILE_DIALOG = 'UnsupportedFileDialog';

export const UnsupportedFileDialog = connect(false, (dispatch) => ({
  hideDialog: () => dispatch(hideDialogAction(UNSUPPORTED_FILE_DIALOG)),
}))(({ hideDialog }) => {
  const { t } = useTranslation();

  return (
    <DialogDecorated dialogName={UNSUPPORTED_FILE_DIALOG}>
      <DialogTitle>
        <h2>{t('unsupported_file_type')}</h2>
      </DialogTitle>
      <DialogBody>
        <div className="ct-stp1-dialog-body">
          <p>{t('unsupported_file_type_message')}</p>
        </div>
      </DialogBody>
      <DialogFooter>
        <div className="ct-stp1-dialog-footer buttons">
          <Button secondary={true} onClick={() => hideDialog()}>
            {t('close')}
          </Button>
        </div>
      </DialogFooter>
    </DialogDecorated>
  );
});
